import * as _ from "lodash";
import * as actions from "user/user/actions";
import { initialUser, LoginUserType } from "user/user/User";
export function UserReducer(currState = initialUser, baseAction) {
    let stateChanges;
    switch (baseAction.type) {
        case actions.USER_LOGIN:
            stateChanges = {
                loggedIn: true
            };
            return _.assign({}, currState, stateChanges);
        case actions.USER_SET_DATA:
            let getDataAction = baseAction;
            stateChanges = {
                loggedIn: true,
                userInfo: getDataAction.userInfo,
                loginUserType: getDataAction.loginUserType,
                userAccess: getDataAction.userAccess
            };
            return _.assign({}, currState, stateChanges);
        case actions.USER_LOGOUT:
            stateChanges = {
                loggedIn: false,
                userInfo: null,
                loginUserType: LoginUserType.Unknown,
                userAccess: null
            };
            return _.assign({}, currState, stateChanges);
    }
    return currState;
}
